import { handleConvertHistoryRecordCiteText } from './parseResponseData'

function generateRandomId() {
    let d = new Date().getTime()
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now() // use high-precision timer if available
    }

    const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })

    return id
}

var createNewMessage = function({role='user', topic_message_id='', updated_at='', text='', reasoning='', is_reasoning=false, reasoning_time=-1, status='pass', image_ids=[], suggestion=[], image_urls=[], search_result=[], material_upload_image=undefined, text_query_image='', is_material_response_images=false}={}) {
    let temp_message_id = generateRandomId()

    let d = {
        id: '',
        message_id: topic_message_id === '' ? temp_message_id : topic_message_id,
        topic_message_id: topic_message_id === '' ? temp_message_id : topic_message_id,
        query_at: updated_at === '' ? dateLocalFormat() : updated_at,
        updated_at: updated_at === '' ? dateLocalFormat() : updated_at,
        text: text,
        reasoning: reasoning,
        is_reasoning: is_reasoning,
        reasoning_time: reasoning_time,
        text_extra_img: '',
        text_extra_search: '',
        image_ids: [...image_ids],
        image_urls: [...image_urls],
        suggestion: [...suggestion],
        search_result: [...search_result],
        text_query_image: text_query_image,
        is_material_response_images: is_material_response_images,
        material_upload_image: material_upload_image ? JSON.parse(JSON.stringify(material_upload_image)) : {},
        status: status,
        role: role,
        message_score: -1,
        is_edit: false,
        edit_text: '',
    }

    return d;
}

let dateLocalFormat = function() {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()

    var hour = date.getHours()
    var minu = date.getMinutes()
    var sec = date.getSeconds()

    month = month >= 10 ? month : '0' + month
    day = day >= 10 ? day : '0' + day
    hour = hour >= 10 ? hour : '0' + hour
    minu = minu >= 10 ? minu : '0' + minu
    sec = sec >= 10 ? sec : '0' + sec

    return `${year}-${month}-${day} ${hour}:${minu}:${sec}`
}

var createNewConversation = function({topic_id='', active=true, name='新的对话'}={}) {
    let d = {
        id: '',
        conversation_id: '',
        conversation_name: name,
        conversation_name_edit: '',
        created_at: '',
        is_edit_name: false,
        has_get_images: false,
        is_collection: false,
        favorites_type: '',
        topic_id: topic_id === '' ? generateRandomId() : topic_id,
        active: active,
        data: [],
    }

    return d;
}

var generateOptionsByChatData = function(filter_category_list, all_chat_data) {
    let result = [];

    let active_category = filter_category_list.find(option => option.active)?.value

    if (active_category === 'all') {
        // 如果传入'all'，则返回所有类别的数据
        filter_category_list.forEach(filterCategory => {
            if (filterCategory.value !== 'all') { // 排除'all'
                result.push({
                    value: filterCategory.label,
                    data_date: filterCategory.value,
                    data: all_chat_data[filterCategory.value]
                            .filter(conversation => conversation.favorites_type !== '' && conversation.favorites_type !== null)
                            .map(conversation => ({
                                id: conversation.id,
                                conversation_id: conversation.conversation_id,
                                conversation_name: conversation.conversation_name,
                                conversation_name_edit: conversation.conversation_name_edit,
                                created_at: conversation.created_at,
                                is_edit_name: conversation.is_edit_name,
                                favorites_type: conversation.favorites_type,
                                topic_id: conversation.topic_id,
                                has_get_images: conversation.has_get_images,
                                active: conversation.active,
                                data: conversation.data
                            }))
                });
            }
        });
    } else {
        // 否则，只返回特定类别的数据
        let categoryLabel = filter_category_list.find(item => item.value === active_category).label;
        result.push({
            value: categoryLabel,
            data_date: active_category,
            data: all_chat_data[active_category]
                    .filter(conversation => conversation.favorites_type !== '' && conversation.favorites_type !== null)
                    .map(conversation => ({
                        id: conversation.id,
                        conversation_id: conversation.conversation_id,
                        conversation_name: conversation.conversation_name,
                        conversation_name_edit: conversation.conversation_name_edit,
                        created_at: conversation.created_at,
                        is_edit_name: conversation.is_edit_name,
                        favorites_type: conversation.favorites_type,
                        topic_id: conversation.topic_id,
                        has_get_images: conversation.has_get_images,
                        active: conversation.active,
                        data: conversation.data
                    }))
        });
    }

    return result;
    /*
        [
            {
                value: '今天',
                data: [
                    {
                        id: '',
                        conversation_id: '',
                        conversation_name: '新的对话',
                        conversation_name_edit: '',
                        created_at: "2024-06-07 04:00:11",
                        is_edit_name: false,
                        favorites_type: '',
                        topic_id: '123',
                        has_get_images: false,
                        active: false,
                        data: [],
                    },
                ],
            },
        ]
    */
}

var transformDateList = function(chatDateList) {
    return chatDateList.map(item => ({
        'days_start': item.days_start,
        'days_end': item.days_end
    }));
}

var formatResponseConversationsDataToLocal = function(conversations) {
    return conversations.map((conversation, index) => {
        let conversation_name = conversation.conversation_name
        if (!conversation_name) {
            conversation_name = "新的对话"
        }

        return {
            id: conversation.id,
            // uuid: conversation.uuid,
            conversation_id: conversation.conversation_id,
            conversation_name: conversation_name,
            conversation_name_edit: '',
            created_at: conversation.created_at,
            is_edit_name: false,
            favorites_type: conversation.favorites_type,
            topic_id: conversation.conversation_id,
            has_get_images: false,
            active: false,
            is_collection: conversation.is_collection,
            // active: index === 0,    // 第一个对话的 active 为 true，其他的为 false
            data: []
        };
    });
}

var formatResponseMessagesDataToLocal = function({data={}, mall_components_list=null}) {
    let messages = data.message

    // 根据 conversation_id 查找对应的消息并转换格式
    const d = messages ? messages.reduce((acc, message) => {
        if (message.response_extra?.query_image) {
            // 材料模式数据的处理
            acc.push({
                id: message.id,
                message_id: message.message_id,
                topic_message_id: `${message.message_id}query`,
                // conversation_id: message.conversation_id,
                query_at: message.query_at,
                updated_at: message.updated_at,
                text: message.query,
                reasoning: '',
                is_reasoning: false,
                reasoning_time: -1,
                text_extra_img: '',
                text_extra_search: '',
                image_ids: [],
                image_urls: [],
                suggestion: [],
                search_result: [],
                text_query_image: transformMaterialQueryImage(message.response_extra?.query_image?.meta_data?.tb_url ? message.response_extra?.query_image?.meta_data?.tb_url : '', message.response_extra?.query_image?.url ? message.response_extra?.query_image?.url : ''),
                is_material_response_images: false,
                material_upload_image: message.response_extra?.query_image ? message.response_extra?.query_image : {},
                role: 'user',
                status: 'pass',
                message_score: -1,
                is_edit: false,
                edit_text: '',
            });

            acc.push({
                id: message.id,
                message_id: message.message_id,
                topic_message_id: message.message_id,
                // conversation_id: message.conversation_id,
                query_at: message.query_at,
                updated_at: message.updated_at,
                // text: message.response,
                text: transformMaterialResponseImage(message.response_extra?.response_images ? message.response_extra?.response_images : {}, message.message_id),
                reasoning: handleConvertHistoryRecordCiteText({message_text: message.response_extra?.reasoning ? message.response_extra?.reasoning : '', mall_components_list: mall_components_list}),
                is_reasoning: message.response_extra?.reasoning ? true : false,
                reasoning_time: message.response_extra?.reasoning_time ? message.response_extra?.reasoning_time : -1,
                text_extra_img: '',
                text_extra_search: searchResultTemplate(message.response_extra?.search_result ? message.response_extra.search_result : []),
                image_ids: message.response_extra?.images ? message.response_extra?.images : (message.response_extra?.image_ids ? message.response_extra.image_ids : []),
                suggestion: message.response_extra?.suggestion ? message.response_extra.suggestion : [],
                search_result: message.response_extra?.search_result ? message.response_extra.search_result : [],
                image_urls: [],
                text_query_image: '',
                is_material_response_images: message.response_extra?.response_images ? true : false,
                material_upload_image: {},
                role: 'ai',
                status: 'pass',
                message_score: message.feedback_score,
                is_edit: false,
                edit_text: '',
                is_collection: message.is_collection,
            });
        } else {
            // 正常问答模式数据的处理
            // 总是添加 query 部分
            acc.push({
                id: message.id,
                message_id: message.message_id,
                topic_message_id: `${message.message_id}query`,
                // conversation_id: message.conversation_id,
                query_at: message.query_at,
                updated_at: message.updated_at,
                text: message.query,
                reasoning: '',
                is_reasoning: false,
                reasoning_time: -1,
                text_extra_img: '',
                text_extra_search: '',
                image_ids: [],
                image_urls: [],
                suggestion: [],
                search_result: [],
                text_query_image: '',
                is_material_response_images: false,
                material_upload_image: {},
                role: 'user',
                status: 'pass',
                message_score: -1,
                is_edit: false,
                edit_text: '',
            });

            // 如果 response 不是空字符串，则添加 response 部分
            if (message.response_extra?.reasoning !== "" || message.response !== "") {
                acc.push({
                    id: message.id,
                    message_id: message.message_id,
                    topic_message_id: message.message_id,
                    // conversation_id: message.conversation_id,
                    query_at: message.query_at,
                    updated_at: message.updated_at,
                    // text: message.response,
                    text: handleConvertHistoryRecordCiteText({message_text: message.response, mall_components_list: mall_components_list}),
                    reasoning: handleConvertHistoryRecordCiteText({message_text: message.response_extra?.reasoning ? message.response_extra?.reasoning : '', mall_components_list: mall_components_list}),
                    is_reasoning: message.response_extra?.reasoning ? true : false,
                    reasoning_time: message.response_extra?.reasoning_time ? message.response_extra?.reasoning_time : -1,
                    text_extra_img: '',
                    text_extra_search: searchResultTemplate(message.response_extra?.search_result ? message.response_extra.search_result : []),
                    image_ids: message.response_extra?.images ? message.response_extra?.images : (message.response_extra?.image_ids ? message.response_extra.image_ids : []),
                    suggestion: message.response_extra?.suggestion ? message.response_extra.suggestion : [],
                    search_result: message.response_extra?.search_result ? message.response_extra.search_result : [],
                    image_urls: [],
                    text_query_image: '',
                    is_material_response_images: false,
                    material_upload_image: {},
                    role: 'ai',
                    status: 'pass',
                    message_score: message.feedback_score,
                    is_edit: false,
                    edit_text: '',
                    is_collection: message.is_collection,
                });
            }
        }

        return acc;
    }, []) : []; // 如果没有消息，则 d 为空数组

    return d
}

var removeHtmlTags = function(html) {
    var div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
}

var formatCollectMessageDataToLocal = function({data=[], mall_components_list=null}) {
    let messages = data

    // 根据 conversation_id 查找对应的消息并转换格式
    const d = messages ? messages.reduce((acc, message) => {
        acc.push({
            id: message.id,
            message_id: message.message_id,
            topic_message_id: message.message_id,
            conversation_id: message.conversation_id,
            query_at: message.query_at,
            updated_at: message.updated_at,
            // text: message.response,
            text: handleConvertHistoryRecordCiteText({message_text: message.response, mall_components_list: mall_components_list}),
            text_extra_img: '',
            text_extra_search: searchResultTemplate(message.response_extra?.search_result ? message.response_extra.search_result : []),
            image_ids: message.response_extra?.images ? message.response_extra?.images : (message.response_extra?.image_ids ? message.response_extra.image_ids : []),
            suggestion: message.response_extra?.suggestion ? message.response_extra.suggestion : [],
            search_result: message.response_extra?.search_result ? message.response_extra.search_result : [],
            image_urls: [],
            role: 'ai',
            status: 'pass',
            message_score: message.feedback_score,
            is_edit: false,
            edit_text: '',
            is_collection: message.is_collection,
        });

        return acc;
    }, []) : []; // 如果没有消息，则 d 为空数组

    return d
}

var searchResultTemplate = (data) => {
    let temp = ''
    data.forEach((item, index) => {
        temp += `<div class="msg_search_result_item"><div class="msg_search_result_item_n">${index + 1}</div><a class="msg_search_result_item_link" href="${item.seeMoreUrl}" target="_blank"><div class="msg_search_result_item_info"><span class="msg_search_result_item_info_title">${item.title ? item.title + " : " : ''}</span><span class="msg_search_result_item_info_text">${item.snippet ? removeHtmlTags(item.snippet) : ''}</span></div></a></div>`
        if (data.length !== index + 1) {
            temp += `<div class="msg_search_result_item_line"></div>`
        }
    })

    if (temp === '') {
        return temp
    } else {
        let template = `<div class="msg_search_result_container msg_search_result_container_shrink"><div class="msg_search_result_title_box"><span class="msg_search_result_title">${data.length}处资料引用</span><div class="msg_search_result_title_icon"></div></div><div class="msg_search_result_item_box">${temp}</div></div>\n`
        return template
    }
}

var transformMaterialQueryImage = (tb_url, url) => {
    if (url === '') {
        return ''
    } else {
        return `<img class="material_mode_query_img" data-url="${url}" src="${tb_url}" />` + `\n`
    }
}

var transformMaterialResponseImage = (data, message_id) => {
    // <div class="material_mode_info_container">
    //     {
    //         data.map((item, index) => {
    //             return (
    //                 <div
    //                     class="material_mode_item"
    //                     key={item.id}
    //                 >
    //                     <div class="material_mode_number_box">
    //                         <span class="material_mode_item_no">NO</span>
    //                         <span class="material_mode_item_number">{index + 1}</span>
    //                     </div>
    //                     <div class="material_mode_item_image_box">
    //                         <img class="material_mode_item_image" src={item.tb_url ? item.tb_url : item.url} data-url={item.tb_url ? item.tb_url : item.url} />
    //                     </div>
    //                     <div class="material_mode_item_text_box">
    //                         <div class="material_mode_item_info">
    //                             <span class="material_mode_item_title">产品名: </span>
    //                             <span class="material_mode_item_text">{item.name}</span>
    //                         </div>
    //                         <div>
    //                             <span class="material_mode_item_title">类别: </span>
    //                             <span class="material_mode_item_text">
    //                                 {
    //                                     item.meta_data?.primary ? item.meta_data?.primary : ''
    //                                 }
    //                                 -
    //                                 {
    //                                     item.meta_data?.secondary ? item.meta_data?.secondary : ''
    //                                 }
    //                             </span>
    //                         </div>
    //                     </div>
    //                 </div>
    //             )
    //         })
    //     }
    // </div>
    if (data?.color_lab.length === 0 && data?.default.length === 0) {
        return ''
    }

    if (!message_id) {
        message_id = "tab_input_"
    }

    let color_lab_list = data?.color_lab ? data?.color_lab : []
    let default_list = data?.default ? data?.default : []

    let default_r = default_list.map((item, index) => {
        return (`<div class="material_mode_item" data-image_id="${item.image_id}">
                <div class="material_mode_number_box">
                    <span class="material_mode_item_no">NO</span>
                    <span class="material_mode_item_number">${index + 1}</span>
                </div>
                <div class="material_mode_item_image_box">
                    <img class="material_mode_item_image" src=${item.tb_url ? item.tb_url : item.url} data-url=${item.tb_url ? item.tb_url : item.url} />
                </div>
                <div class="material_mode_item_text_box">
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">产品名: </span>
                        <span class="material_mode_item_text">${item.name}</span>
                    </div>
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">类别: </span>
                        <span class="material_mode_item_text">${item.tags[0] ?? ''}-${item.tags[1] ?? ''}</span>
                    </div>
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">品牌: </span>
                        <span class="material_mode_item_text">${item.meta_data?.supplier_name ?? ''}</span>
                    </div>
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">价格: </span>
                        <span class="material_mode_item_text">${parseInt(item.meta_data?.min_price ?? 0) === parseInt(item.meta_data?.max_price ?? 0) ? parseInt(item.meta_data?.min_price ?? 0) : parseInt(item.meta_data?.min_price ?? 0) + '-' + parseInt(item.meta_data?.max_price ?? 0) } 元/平</span>
                    </div>
                </div>
            </div>`
        )
    })

    let color_r = color_lab_list.map((item, index) => {
        return (`<div class="material_mode_item" data-image_id="${item.image_id}">
                <div class="material_mode_number_box">
                    <span class="material_mode_item_no">NO</span>
                    <span class="material_mode_item_number">${index + 1}</span>
                </div>
                <div class="material_mode_item_image_box">
                    <img class="material_mode_item_image" src=${item.tb_url ? item.tb_url : item.url} data-url=${item.tb_url ? item.tb_url : item.url} />
                </div>
                <div class="material_mode_item_text_box">
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">产品名: </span>
                        <span class="material_mode_item_text">${item.name}</span>
                    </div>
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">类别: </span>
                        <span class="material_mode_item_text">${item.tags[0] ?? ''}-${item.tags[1] ?? ''}</span>
                    </div>
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">品牌: </span>
                        <span class="material_mode_item_text">${item.meta_data?.supplier_name ?? ''}</span>
                    </div>
                    <div class="material_mode_item_info">
                        <span class="material_mode_item_title">价格: </span>
                        <span class="material_mode_item_text">${parseInt(item.meta_data?.min_price ?? 0) === parseInt(item.meta_data?.max_price ?? 0) ? parseInt(item.meta_data?.min_price ?? 0) : parseInt(item.meta_data?.min_price ?? 0) + '-' + parseInt(item.meta_data?.max_price ?? 0) } 元/平</span>
                    </div>
                </div>
            </div>`
        )
    })

    // return `<div class="material_mode_info_container">${r.join('')}</div>`
    return `<div class="material_mode_info_container"><div class="material_mode_info_tabs_container"><input type="radio" name="${message_id}" id="material_mode_info_tab_id_${message_id}id1" checked /><input type="radio" name="${message_id}" id="material_mode_info_tab_id_${message_id}id2" /><div class="material_mode_info_tab"><label class="material_mode_info_tab_label1" for="material_mode_info_tab_id_${message_id}id1">纹理</label><div class="material_mode_info_tab_div_line"></div><label class="material_mode_info_tab_label2" for="material_mode_info_tab_id_${message_id}id2">颜色</label></div><div class="material_mode_info_tab_contents"><div class="material_mode_info_tab_content material_mode_info_tab_content1">${default_r.join('')}</div><div class="material_mode_info_tab_content material_mode_info_tab_content2">${color_r.join('')}</div></div></div></div>`
}

export {
    generateRandomId,
    createNewMessage,
    createNewConversation,
    generateOptionsByChatData,
    transformDateList,
    formatResponseConversationsDataToLocal,
    formatResponseMessagesDataToLocal,
    removeHtmlTags,
    formatCollectMessageDataToLocal,
    searchResultTemplate,
    transformMaterialQueryImage,
    transformMaterialResponseImage,
}
